import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import { NavBar, Button, Form, Field, Checkbox, Popup, Dialog, Toast } from 'vant'
import 'vant/lib/index.css'
import router from './router'

const app = createApp(App)
app.use(NavBar)
app.use(Button)
app.use(Form)
app.use(Field)
app.use(Checkbox)
app.use(Popup)
app.use(Dialog)
app.use(Toast)
app.use(router)
app.mount('#app')
